module.exports = __webpack_public_path__ + "static/media/6.d169ddc6.jpg";